import { Base } from './base';
// import { Util } from './index';

export class Browser extends Base {

    constructor() {
        super();
    }

}
